export default (event, funnelName, method, risk, subFunnelName) => {
  return {
    event,
    'funnel_name': funnelName,
    'sub_funnel_name': subFunnelName,
    method,
    risk,
  };
};
